import * as React from "react";
import { Customers } from "@grandvisionhq/api-client";
import { Selectors, State, getToken } from "@grandvisionhq/auth";
import { useSelector, useApiConfig } from "@grandvisionhq/state";
function useGetPrescriptionSignatures() {
  const auth = useSelector(Selectors.getAuth);
  const { apiUrl } = useApiConfig();
  const isLoggedIn = State.isLoggedIn(auth);
  const [prescriptionSignatures, setPrescriptionSignatures] = React.useState(
    void 0
  );
  if (!isLoggedIn) {
    throw new Error(`User needs to be logged in to fetch signed prescriptions`);
  }
  React.useEffect(() => {
    (async () => {
      try {
        const accessToken = await getToken();
        const { prescriptionTokens } = await Customers.Prescriptions.signedPrescriptions(
          apiUrl,
          accessToken,
          {
            customerId: auth.userId
          }
        );
        if (prescriptionTokens) {
          setPrescriptionSignatures(JSON.stringify(prescriptionTokens));
        }
      } catch (err) {
        throw new Error(`Failed to fetch signed prescriptions: ${err}`);
      }
    })();
  }, [apiUrl, auth.userId]);
  return { prescriptionSignatures };
}
export {
  useGetPrescriptionSignatures
};
//# sourceMappingURL=use-get-prescription-signatures.js.map
